///
/// Copyright (c) 2017-present, Siklu Ltd.
/// All rights reserved.
///

import { Pipe, PipeTransform } from '@angular/core';
import { feetMultiplier } from '../utils';

@Pipe({
    name: 'FeetConvert'
})
export class FeetConvert implements PipeTransform {
    transform(value: number, units: string): number {
        if (units === 'feet') {
            return Math.round(value / feetMultiplier);
        } else {
            return value;
        }
    }
}
